import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useApi from "../../../core/customhook/useApi";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import ReactApexChart from "react-apexcharts";
import Swal from "sweetalert2";
import { getFinancialYearListNew } from "../../../core/common/financialYear";

const AllEmployeesHod = () => {
  const [count, setCount] = useState(0);
  const [ratingData, setRatingData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedRecs, setSelectedRecs] = useState({});
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [callAPiRecomandation, setCallAPiRecomandation] = useState(false);

  const [finance_year, setFinance_year] = useState("");

  const {
    data: finYearData,
    loading: finYearLoading,
    error: finYearError,
  } = useApi("/api/get-apprisal-fin-year", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (finYearData?.data?.fin_year) {
      setFinance_year(finYearData.data.fin_year);
    }
  }, [finYearData]);
  // Map numeric value to rating based on scale
  const mapValueToRating = (value, ratingData) => {
    if (value === null || value === undefined) return "";
    const matched = ratingData.find((r) => {
      const [min, max] = r.scale.split(" - ").map(Number);
      return value >= min && value <= max;
    });
    return matched ? matched.rating : "";
  };

  // Render rating dropdown with prefill
  const renderRatingSelect = (value, record, type) => {
    const selectedRating = mapValueToRating(value, ratingData);
    const isDisabled =
      record.final_status === "Submit" ||
      record.skip_manager_status == null ||
      record.skip_manager_status === "InProgress" ||
      record.skip_manager_status === "Save As Draft Skip Manager";

    return (
      <select
        value={selectedRating}
        className="form-select form-select-sm"
        style={{ width: 180 }}
        disabled={isDisabled}
        onChange={(e) => {
          const newRating = Number(e.target.value);
          setEmployeeData((prev) =>
            prev.map((emp) =>
              emp.employee_id === record.employee_id
                ? type === "HOD_KRA"
                  ? { ...emp, hod_kra_final: newRating }
                  : { ...emp, hod_Potensial_final: newRating }
                : emp,
            ),
          );
        }}
      >
        <option value="">Select</option>
        {ratingData.map((opt) => (
          <option key={opt.rating} value={opt.rating}>
            {opt.name} ({opt.scale})
          </option>
        ))}
      </select>
    );
  };

  const getStatusBadge = (status) => {
    let color = "";
    let label = status;

    switch (status) {
      case null:
      case "Pending":
        color = "bg-secondary";
        label = "Pending";
        break;
      case "InProgress":
        color = "bg-warning";
        break;
      case "proced 1 on 1":
        color = "bg-warning";
        label = "Proceed 1 on 1";
        break;
      case "Draft":
        color = "bg-warning";
        break;
      case "Save As Draft Skip Manager":
        color = "bg-warning";
        break;
      case "Revert to manager":
        color = "bg-warning";
        break;
      case "Submit":
        color = "bg-success";
        label = "Submitted";
        break;
      default:
        color = "bg-secondary";
        label = "Pending";
    }

    return <span className={`badge ${color}`}>{label}</span>;
  };

  const renderReadonlySelect = (value, record, type) => {
    if (value === null || value === undefined) {
      return "-";
    }

    const selectedRating = mapValueToRating(value, ratingData);

    return (
      <select
        value={selectedRating}
        className="form-control form-select-sm"
        style={{ width: 180 }}
        disabled // always readonly
      >
        <option value="">Select</option>
        {ratingData.map((opt) => (
          <option key={opt.rating} value={opt.rating}>
            {opt.name} ({opt.scale})
          </option>
        ))}
      </select>
    );
  };

  const openRecommendationModal = (record) => {
    setSelectedEmployee(record);
  };

  const columns = [
    { title: "SNo.", dataIndex: "srNo" },

    {
      title: "Employee Id",
      dataIndex: "employee_id",
      render: (text) => <p>{text}</p>,
      sorter: (a, b) => a.employee_id.localeCompare(b.employee_id),
    },
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      render: (text) => <p>{text}</p>,
      sorter: (a, b) => a.employee_name.localeCompare(b.employee_name),
      onCell: () => ({
        style: { whiteSpace: "nowrap" },
      }),
    },
    {
      title: "Designation",
      dataIndex: "designation",
      onCell: () => ({
        style: { whiteSpace: "nowrap" },
      }),
    },
    {
      title: "Department",
      dataIndex: "department",
      onCell: () => ({
        style: { whiteSpace: "nowrap" },
      }),
    },
    {
      title: "R2 KRA Rating",
      dataIndex: "skip_manager_kra_final",
      render: (value, record) => renderReadonlySelect(value, record, "R2_KRA"),
    },
    {
      title: "R2 Potential Rating",
      dataIndex: "skip_manager_Potensial_final",
      render: (value, record) =>
        renderReadonlySelect(value, record, "R2_POTENTIAL"),
    },
    {
      title: "HOD KRA Rating",
      dataIndex: "hod_kra_final",
      render: (value, record) => renderRatingSelect(value, record, "HOD_KRA"),
    },
    {
      title: "HOD Potential Rating",
      dataIndex: "hod_Potensial_final",
      render: (value, record) =>
        renderRatingSelect(value, record, "HOD_POTENTIAL"),
    },
    {
      title: "PMS Rating",
      dataIndex: "pms_number",
      render: (_, record) => {
        if (record.pms_number && record.pms_category) {
          return `${record.pms_category} - ${record.pms_number}`;
        } else {
          return "-";
        }
      },
      onCell: () => ({
        style: { whiteSpace: "nowrap" },
      }),
    },
    {
      title: "Recommendation",
      render: (_, record) => (
        <button
          className="btn btn-outline-secondary"
          data-bs-toggle="modal"
          data-bs-target="#recomandations"
          title="View Rating Info"
          onClick={() => {
            openRecommendationModal(record);
            setCallAPiRecomandation(true);
          }}
          disabled={record.skip_manager_status !== "Submit"}
        >
          👁
        </button>
      ),
    },
    {
      title: "Update",
      dataIndex: "hod_Potensial_final",
      render: (value, record) => {
        const today = new Date();

        const isExpired =
          record.hod_end_date &&
          new Date(record.hod_end_date) <
            new Date(today.toISOString().split("T")[0]);

        const isCycleClosedOrSuspended =
          record.apprisal_cycle_status === "closed" ||
          record.apprisal_cycle_status === "suspended";

        const isDisabled =
          record.final_status === "Submit" ||
          record.hod_kra_final === null ||
          record.hod_Potensial_final === null ||
          isExpired ||
          isCycleClosedOrSuspended;

        return (
          <button
            className="btn btn-sm btn-primary"
            onClick={() => handleHodUpdate(record)}
            disabled={isDisabled}
          >
            Update
          </button>
        );
      },
    },
    {
      title: "Select",
      dataIndex: "self_status",
      render: (value, record) => (
        <input
          type="checkbox"
          className=""
          disabled={
            record.hod_status === null || record.final_status === "Submit"
          }
          checked={selectedEmployees.includes(record.employee_id)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedEmployees((prev) => [...prev, record.employee_id]);
            } else {
              setSelectedEmployees((prev) =>
                prev.filter((id) => id !== record.employee_id),
              );
            }
          }}
        />
      ),
    },
    {
      title: "Status",
      dataIndex: "hod_status",
      render: (text) => getStatusBadge(text),
    },
    {
      title: "Skip Manager Status",
      dataIndex: "skip_manager_status",
      render: (text) => getStatusBadge(text),
    },
    {
      title: "Manager Status",
      dataIndex: "manager_status",
      render: (text) => getStatusBadge(text),
    },
    {
      title: "Employee Status",
      dataIndex: "self_status",
      render: (text) => getStatusBadge(text),
    },
    {
      title: "View",
      render: (_, record) => {
        const disabledStatuses = [
          "Pending",
          "InProgress",
          null,
          "Save As Draft Skip Manager",
        ];
        const isDisabled = disabledStatuses.includes(
          record.skip_manager_status,
        );

        return isDisabled ? (
          <div
            className="btn btn-sm btn-primary custom_button d-flex align-items-center justify-content-center w-35"
            style={{ cursor: "not-allowed", opacity: 0.5 }}
            title="Cannot view details"
          >
            <i className="ti-eye" />
          </div>
        ) : (
          <Link
            to={`/pms-review-hod/${record.employee_id}`}
            className="btn btn-sm btn-primary custom_button d-flex align-items-center justify-content-center w-35"
            title="View Details"
          >
            <i className="ti-eye" />
          </Link>
        );
      },
    },
  ];

  const {
    data: getRatingdetails,
    loading: RatingdetailsLoading,
    error: RatingdetailsError,
  } = useApi("/api/get-rating", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: getpmsgrade,
    loading: pmsgradeLoading,
    error: pmsgradeError,
  } = useApi("/api/get-hod-pms-grade-mapping", {
    method: "GET",
    autoCall: true,
  });

  useEffect(() => {
    if (getRatingdetails?.success) {
      setRatingData([...getRatingdetails?.data].reverse());
    }
  }, [getRatingdetails]);

  const {
    data: getAllEmployee,
    loading: AllEmployeeLoading,
    error: AllEmployeeError,
  } = useApi("/api/hod-all-employee", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: !!finance_year,
    dependencies: [finance_year, count],
  });

  useEffect(() => {
    if (getAllEmployee?.success) {
      const srData = getAllEmployee?.data?.map((item, index) => {
        return {
          ...item,
          srNo: index + 1,
          recommendation: item.recommendation || {
            type_id: "",
            to_location_id: "",
            to_designation_id: "",
            justification: "",
          },
        };
      });
      setEmployeeData(srData);
    }
  }, [getAllEmployee]);

  const handleRecommendationTypeChange = (
    employee_id,
    type_id,
    updatedRec = null,
  ) => {
    setEmployeeData((prev) =>
      prev.map((emp) => {
        if (emp.employee_id !== employee_id) return emp;
        if (updatedRec) {
          return {
            ...emp,
            recommendation: {
              ...emp.recommendation,
              ...updatedRec,
            },
          };
        }
        return {
          ...emp,
          recommendation: {
            type_id,
            justification: "",
            from_location_id: null,
            to_location_id: null,
            from_designation_id: null,
            to_designation_id: null,
            market_adjustment: 0,
            training_type: null,
          },
        };
      }),
    );
  };

  const handleCheckboxChange = (typeId, checked) => {
    setSelectedRecs((prev) => ({
      ...prev,
      [typeId]: {
        ...prev[typeId],
        selected: checked,
      },
    }));
  };

  const handleRecChange = (typeId, field, value) => {
    setSelectedRecs((prev) => ({
      ...prev,
      [typeId]: {
        ...prev[typeId],
        [field]: value,
      },
    }));
  };

  const increaseMarket = () => {
    setSelectedRecs((prev) => {
      let current = Number(prev[8]?.adjustment || 0);

      let next = current + 0.01;

      if (next > 100) next = 100;

      return {
        ...prev,
        8: {
          ...prev[8],
          adjustment: Number(next.toFixed(2)),
        },
      };
    });
  };

  const decreaseMarket = () => {
    setSelectedRecs((prev) => {
      let current = Number(prev[8]?.adjustment || 0);

      let next = current - 0.01;

      if (next < 0) next = 0;

      return {
        ...prev,
        8: {
          ...prev[8],
          adjustment: Number(next.toFixed(2)),
        },
      };
    });
  };

  const {
    data: FinalRating,
    loading: FinalRatingLoading,
    error: FinalRatingError,
    callApi: addFinalRating,
  } = useApi("/api/add-hod-final-rating", {
    method: "POST",
    autoCall: false,
    dependencies: [finance_year],
  });

  const handleHodUpdate = async (record) => {
    const updatedRecord = employeeData.find(
      (emp) => emp.employee_id === record.employee_id,
    );

    const payload = {
      employee_id: updatedRecord.employee_id,
      financial_year: finance_year,
      hod_kra_final: updatedRecord.hod_kra_final ?? null,
      hod_Potensial_final: updatedRecord.hod_Potensial_final ?? null,
      role: "HOD",
    };
    try {
      const response = await addFinalRating(payload);
      if (response.success) {
        Swal.fire({
          title: "Success!",
          text: response?.message,
          icon: "success",
          confirmButtonText: "OK",
        });
        setCount(count + 1);
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const {
    data: getpmsChart,
    loading: pmsChartLoading,
    error: pmsChartError,
  } = useApi("/api/hod/pms-chart", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: !!finance_year,
    dependencies: [finance_year, count],
  });

  // useEffect(() => {
  //   if (getpmsChart?.success) {
  //     const chartData = getpmsChart.chart;

  //     // Map employee counts
  //     const counts = chartData.map((item) => Number(item.employee_count));

  //     setPmsChart((prev) => ({
  //       ...prev,
  //       series: [
  //         {
  //           name: "Employee Count",
  //           data: counts,
  //         },
  //       ],
  //       yaxis: {
  //         ...prev.yaxis,
  //         max: Math.max(...counts) + 1,
  //       },
  //     }));
  //   }
  // }, [getpmsChart]);

  useEffect(() => {
    if (getpmsChart?.success) {
      const chartData = getpmsChart.chart || [];
      const totalEmployees = getpmsChart.total_employee || 0;

      // ACTUAL DATA FROM API
      const actualCounts = chartData.map((item) =>
        Number(item.employee_count || 0),
      );

      // IDEAL CALCULATED DATA
      const incompatible = Math.round(totalEmployees * 0.1);
      const valued = Math.round(totalEmployees * 0.8);
      const top = totalEmployees - incompatible - valued;

      const idealCounts = [incompatible, valued, top];

      const VariansCounts = idealCounts.map(
        (ideal, index) => ideal - (actualCounts[index] || 0),
      );

      setPmsChart((prev) => ({
        ...prev,
        series: [
          {
            name: "Actual Employee",
            data: actualCounts,
          },
          {
            name: "Ideal Distribution",
            data: idealCounts,
          },
          {
            name: "Variance",
            data: VariansCounts,
          },
        ],
        options: {
          ...prev.options,
          yaxis: {
            min: 0,
            max: Math.max(...actualCounts, ...idealCounts, totalEmployees) + 1,
            tickAmount: 5,
            labels: {
              formatter: function (val) {
                return Math.round(val);
              },
            },
          },
        },
      }));
    }
  }, [getpmsChart]);
  const [pmsChart, setPmsChart] = React.useState({
    // series: [
    //   {
    //     name: "Performance",
    //     data: [30, 60, 45, 70, 50], // example mountain shape
    //   },
    // ],
    series: [
      {
        name: "Actual Employee",
        data: [],
      },
      {
        name: "Ideal Distribution",
        data: [],
      },
      {
        name: "Variance",
        data: [],
      },
    ],
    options: {
      chart: {
        height: 300,
        type: "area", // ✅ CHANGE FROM BAR
        toolbar: { show: false },
      },

      colors: ["#1E88E5", "#FF9800", "#E53935"],

      // stroke: {
      //   curve: "smooth", // ✅ Smooth mountain line
      //   width: 3,
      // },
      stroke: {
        curve: "smooth",
        width: [4, 4, 3],

        // solid + dashed
        dashArray: [0, 8, 3],
      },

      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.6,
          opacityTo: 0.1,
        },
      },

      dataLabels: {
        enabled: false,
      },

      xaxis: {
        categories: [
          ["Incompatible", "Talent"],
          ["Valued", "Talent"],
          ["Top", "Talent"],
        ],
        labels: {
          trim: false,
          style: {
            fontSize: "14px",
            fontWeight: 700,
            colors: ["#333"],
          },
        },
      },

      yaxis: {
        min: 0,
        // max: 100, // ✅ set max employee count
        // tickAmount: 5, // ✅ number of steps
        // labels: {
        //   formatter: function (val) {
        //     return Math.round(val); // ✅ remove decimal
        //   },
        // },
      },

      markers: {
        size: 4,
      },
      tooltip: {
        shared: true,
        intersect: false,

        y: {
          formatter: function (value, { seriesIndex }) {
            if (seriesIndex === 2) {
              return `${value} Difference`;
            }

            return `${value} Employees`;
          },
        },
      },

      // ================= LEGEND =================
      legend: {
        show: true,
        position: "top",
      },
    },
  });

  const {
    data: finalsubmitpms,
    loading: finalsubmitpmsLoading,
    error: finalsubmitpmsError,
    callApi: HodFinalsubmit,
  } = useApi("/api/hod/final-submit", {
    method: "POST",
    payload: {
      financial_year: finance_year,
    },
    autoCall: false,
  });

  const finalSubmitHodEND = async () => {
    try {
      const payload = {
        financial_year: finance_year,
        selectedEmployees,
      };
      const response = await HodFinalsubmit(payload);
      if (response?.success) {
        setCount(count + 1);
        Swal.fire({
          icon: "success",
          title: "Submitted Successfully!",
          text:
            response?.message ||
            "HOD review has been submitted for the selected employees.",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {}
  };

  const {
    data: getRecommendationType,
    loading: RecommendationTypeLoading,
    error: RecommendationTypeError,
  } = useApi("/api/get-recommendation-type", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: getworkLocatation,
    loading: workLocatationLoading,
    error: workLocatationError,
  } = useApi("/api/get-workLocatation", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: profileResponse,
    error: profileResponseError,
    loading: profileResponseLoading,
  } = useApi(`/api/get-employee-details/${selectedEmployee?.employee_id}`, {
    method: "GET",
    autoCall: !!selectedEmployee?.employee_id,
    dependencies: [selectedEmployee?.employee_id],
  });

  const { data: upperDesignations, loading: upperDesignationsLoading } = useApi(
    `/api/get-employee-upper-designations/${selectedEmployee?.employee_id}`,
    {
      method: "GET",
      autoCall: !!selectedEmployee?.employee_id,
      dependencies: [selectedEmployee?.employee_id],
    },
  );

  const { data: reDesignations, loading: reDesignationsLoading } = useApi(
    `/api/get-employee-re-designations/${selectedEmployee?.employee_id}`,
    {
      method: "GET",
      autoCall: !!selectedEmployee?.employee_id,
      dependencies: [selectedEmployee?.employee_id],
    },
  );

  console.log(selectedEmployee, "selectedEmployees");
  console.log(callAPiRecomandation, "callAPiRecomandation");
  const {
    data: getRecomandations,
    error: getRecomandationsError,
    loading: getRecomandationsLoading,
  } = useApi(`/api/get-Recomandations-employee-hod`, {
    method: "POST",
    payload: selectedEmployee?.employee_id
      ? {
          employee_id: selectedEmployee.employee_id,
          financial_year: finance_year,
        }
      : null,
    dependencies: [selectedEmployee?.employee_id, finance_year],
    autoCall: !!selectedEmployee?.employee_id,
  });
  useEffect(() => {
    if (getRecomandations?.data?.length > 0) {
      const mapped = {};

      getRecomandations.data.forEach((rec) => {
        mapped[rec.type_id] = {
          selected: true,
          to_designation: rec.to_designation_id || "",
          to_branch: rec.to_location_id || "",
          adjustment: rec.market_adjustment || "",
          justification: rec.justification || "",
          training_type: rec.training_type || "",
        };
      });

      setSelectedRecs(mapped);
    } else {
      setSelectedRecs({});
    }
  }, [getRecomandations]);
  console.log(getRecomandations, "getRecomandations");

  const { callApi: saveRecoApi, loading: saveRecoLoading } = useApi(
    "/api/save-reco-hod",
    {
      method: "POST",
      autoCall: false,
    },
  );

  const validateRecommendations = () => {
    const errors = [];

    // Promotion
    if (selectedRecs[1]?.selected) {
      if (!selectedRecs[1]?.to_designation) {
        errors.push("Promotion recommendation is required");
      }

      if (!selectedRecs[1]?.justification?.trim()) {
        errors.push("Promotion justification is required");
      }
    }

    // Transfer
    if (selectedRecs[3]?.selected) {
      if (!selectedRecs[3]?.to_branch) {
        errors.push("Transfer location is required");
      }

      if (!selectedRecs[3]?.justification?.trim()) {
        errors.push("Transfer justification is required");
      }
    }

    // Market Adjustment
    if (selectedRecs[8]?.selected) {
      if (
        selectedRecs[8]?.adjustment === "" ||
        selectedRecs[8]?.adjustment === undefined
      ) {
        errors.push("Market adjustment percentage is required");
      }

      if (!selectedRecs[8]?.justification?.trim()) {
        errors.push("Market adjustment justification is required");
      }
    }

    // Re-designation
    if (selectedRecs[9]?.selected) {
      if (!selectedRecs[9]?.to_designation) {
        errors.push("Re-designation is required");
      }

      if (!selectedRecs[9]?.justification?.trim()) {
        errors.push("Re-designation justification is required");
      }
    }

    // Training
    if (selectedRecs[10]?.selected) {
      if (!selectedRecs[10]?.training_type) {
        errors.push("Training type is required");
      }

      if (!selectedRecs[10]?.justification?.trim()) {
        errors.push("Training justification is required");
      }
    }

    // None Of Above
    if (selectedRecs[14]?.selected) {
      if (!selectedRecs[14]?.justification?.trim()) {
        errors.push("Justification is required");
      }
    }

    return errors;
  };

  const buildRecommendationPayload = () => {
    return Object.keys(selectedRecs)
      .filter((key) => selectedRecs[key]?.selected)
      .map((key) => {
        const rec = selectedRecs[key];

        return {
          type_id: Number(key),
          to_designation: rec.to_designation || null,
          to_branch: rec.to_branch || null,
          adjustment: rec.adjustment || 0,
          justification: rec.justification || "",
          training_type: rec.training_type || null,
        };
      });
  };

  const saveRecomandation = async () => {
    try {
      const validationError = validateRecommendations();
      if (validationError.length > 0) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: validationError[0],
          confirmButtonText: "OK",
        });

        return;
      }
      const recommendations = buildRecommendationPayload();

      if (!selectedEmployee?.employee_id) {
        Swal.fire("Error", "Employee not selected", "error");
        return;
      }

      if (recommendations.length === 0) {
        Swal.fire(
          "Warning",
          "Please select at least one recommendation",
          "warning",
        );
        return;
      }

      const payload = {
        employee_id: selectedEmployee?.employee_id,
        financial_year: finance_year,
        recommendations,
      };

      const res = await saveRecoApi(payload);

      if (res?.success) {
        Swal.fire({
          icon: "success",
          title: "Saved!",
          text: res.message || "Recommendation saved successfully",
        }).then(() => {
          document.getElementById("closedRecoModal").click();
        });

        // Optional: refresh data
        // setCallAPiRecomandation(true);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Something went wrong",
      });
    }
  };
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div>
            <h2 className="mb-1">HOD Dashboard</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.employeeDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">PMS</li>
                <li className="breadcrumb-item active">Hod Employee Profile</li>
              </ol>
            </nav>
          </div>
          <div className="d-flex gap-2">
            <select
              value={finance_year}
              onChange={(e) => setFinance_year(e.target.value)}
              className="form-select w-100"
            >
              {getFinancialYearListNew(finance_year).map((fy) => (
                <option key={fy} value={fy}>
                  {fy}
                </option>
              ))}
            </select>
            <div className="head-icons ms-2">
              <CollapseHeader />
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Employee List</h5>
            <div className="d-flex gap-2">
              <button
                className="btn btn-outline-secondary"
                data-bs-toggle="modal"
                data-bs-target="#ratinginfo"
                title="View Rating Info"
              >
                <i className="fa fa-users"></i>
              </button>
            </div>
          </div>

          <div className="card-body p-2">
            <div className="card p-1">
              <div className="d-flex flex-wrap justify-content-center gap-4 mt-5">
                {/* Chart Section */}
                <div
                  className="card"
                  style={{
                    flex: 1,
                    minWidth: "400px",
                    maxWidth: "800px",
                    height: "400px",
                  }}
                >
                  <div className="card-body">
                    {/* <ReactApexChart
                      id="revenue-bar"
                      options={pmsChart}
                      series={pmsChart.series}
                      type="bar"
                      height={370}
                    /> */}

                    <ReactApexChart
                      options={pmsChart.options}
                      series={pmsChart.series}
                      type="area"
                      height={350}
                    />
                  </div>
                </div>
              </div>
              <div className="p-2 d-flex gap-2 justify-content-end mb-2">
                <div>
                  <button
                    className="btn btn-secondary w-100"
                    onClick={() => finalSubmitHodEND()}
                    disabled={selectedEmployees.length === 0}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
            <Table
              dataSource={employeeData || []}
              columns={columns}
              Selection={false}
              limit={5}
              // showSearchInput={true}
            />
          </div>
        </div>
      </div>

      <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
        <p className="mb-0">
          © {new Date().getFullYear()} WeConnect. All rights reserved.
        </p>
      </div>

      <div
        id="ratinginfo"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="standard-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="standard-modalLabel">
                Ratings & Calculation of your score
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body">
              <div className="mb-4">
                <h5>
                  This year we are using a 5 point rating scale. The value
                  assigned to each rating is as below.
                </h5>
              </div>

              {/* Dynamic Ratings Table */}
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Rating</th>
                    <th>Description</th>
                    <th>Code</th>
                    <th>Scale</th>
                  </tr>
                </thead>
                <tbody>
                  {ratingData && ratingData.length > 0 ? (
                    [...ratingData].reverse().map((item, index) => (
                      <tr key={index}>
                        <td>{item.rating}</td>
                        <td>{item.name}</td>
                        <td>{item.code}</td>
                        <td>{item.scale}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center">
                        No rating data found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="mt-3">
                <p>
                  Your score is determined entirely by your score on your
                  KRA/KPI OR a composite where the weight of the KRA is 80%,
                  Potential is 20%
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="recomandations"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="standard-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="standard-modalLabel">
                Recommendations - {selectedEmployee?.employee_name}
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closedRecoModal"
              />
            </div>

            <div className="modal-body">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Recommendation</th>
                    <th>From</th>
                    <th>To / Sub Recommendation</th>
                    <th>Justification</th>
                  </tr>
                </thead>

                <tbody>
                  {/* PROMOTION (1) */}
                  {(() => {
                    const item = getRecommendationType?.data.find(
                      (x) => x.type_id === 1,
                    );
                    if (!item) return null;

                    return (
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedRecs[1]?.selected || false}
                            onChange={(e) =>
                              handleCheckboxChange(1, e.target.checked)
                            }
                          />
                        </td>

                        <td>{item.type_name}</td>

                        <td>
                          <input
                            type="text"
                            value={selectedEmployee?.designation}
                            className="form-control"
                            readOnly
                          />
                        </td>

                        <td>
                          <select
                            className="form-select"
                            disabled={!selectedRecs[1]?.selected}
                            value={selectedRecs[1]?.to_designation || ""}
                            onChange={(e) =>
                              handleRecChange(
                                1,
                                "to_designation",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">Select</option>
                            {upperDesignations?.data.map((d) => (
                              <option
                                key={d.designation_id}
                                value={d.designation_id}
                              >
                                {d.designation}
                              </option>
                            ))}
                          </select>
                        </td>

                        <td>
                          <textarea
                            className="form-control"
                            disabled={!selectedRecs[1]?.selected}
                            value={selectedRecs[1]?.justification || ""}
                            onChange={(e) =>
                              handleRecChange(
                                1,
                                "justification",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* TRANSFER (3) */}
                  {(() => {
                    const item = getRecommendationType?.data.find(
                      (x) => x.type_id === 3,
                    );
                    if (!item) return null;

                    return (
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedRecs[3]?.selected || false}
                            onChange={(e) =>
                              handleCheckboxChange(3, e.target.checked)
                            }
                          />
                        </td>

                        <td>{item.type_name}</td>

                        <td>
                          <input
                            type="text"
                            value={selectedEmployee?.branch_name}
                            className="form-control"
                            readOnly
                          />
                        </td>

                        <td>
                          <select
                            className="form-select"
                            disabled={!selectedRecs[3]?.selected}
                            value={selectedRecs[3]?.to_branch || ""}
                            onChange={(e) =>
                              handleRecChange(3, "to_branch", e.target.value)
                            }
                          >
                            <option value="">Select</option>
                            {getworkLocatation?.data.map((loc) => (
                              <option key={loc.branch_id} value={loc.branch_id}>
                                {loc.branch_name}
                              </option>
                            ))}
                          </select>
                        </td>

                        <td>
                          <textarea
                            className="form-control"
                            disabled={!selectedRecs[3]?.selected}
                            value={selectedRecs[3]?.justification || ""}
                            onChange={(e) =>
                              handleRecChange(
                                3,
                                "justification",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* MARKET ADJUSTMENT (8) */}
                  {(() => {
                    const item = getRecommendationType?.data.find(
                      (x) => x.type_id === 8,
                    );
                    if (!item) return null;

                    return (
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedRecs[8]?.selected || false}
                            onChange={(e) =>
                              handleCheckboxChange(8, e.target.checked)
                            }
                          />
                        </td>

                        <td>{item.type_name}</td>

                        <td colSpan={2}>
                          <div className="d-flex align-items-center gap-2">
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              disabled={!selectedRecs[8]?.selected}
                              onClick={decreaseMarket}
                            >
                              −
                            </button>

                            <input
                              type="text"
                              value={selectedRecs[8]?.adjustment || ""}
                              disabled={!selectedRecs[8]?.selected}
                              className="form-control text-center"
                              style={{ width: "80px" }}
                              onChange={(e) => {
                                let value = e.target.value;

                                if (!/^\d*\.?\d*$/.test(value)) return;

                                handleRecChange(8, "adjustment", value);
                              }}
                              onBlur={() => {
                                let val = selectedRecs[8]?.adjustment;

                                if (val === "" || val === undefined) return;

                                let num = Number(val);

                                if (num > 100) num = 100;
                                if (num < 0) num = 0;

                                handleRecChange(
                                  8,
                                  "adjustment",
                                  num.toFixed(2),
                                );
                              }}
                            />

                            <span>%</span>

                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              disabled={!selectedRecs[8]?.selected}
                              onClick={increaseMarket}
                            >
                              +
                            </button>
                          </div>
                        </td>

                        <td>
                          <textarea
                            className="form-control"
                            disabled={!selectedRecs[8]?.selected}
                            value={selectedRecs[8]?.justification || ""}
                            onChange={(e) =>
                              handleRecChange(
                                8,
                                "justification",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* RE-DESIGNATION (9) */}
                  {(() => {
                    const item = getRecommendationType?.data.find(
                      (x) => x.type_id === 9,
                    );
                    if (!item) return null;

                    return (
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedRecs[9]?.selected || false}
                            onChange={(e) =>
                              handleCheckboxChange(9, e.target.checked)
                            }
                          />
                        </td>

                        <td>{item.type_name}</td>

                        <td colSpan={2}>
                          <select
                            className="form-select"
                            disabled={!selectedRecs[9]?.selected}
                            value={selectedRecs[9]?.to_designation || ""}
                            onChange={(e) =>
                              handleRecChange(
                                9,
                                "to_designation",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">Select</option>
                            {reDesignations?.data.map((d) => (
                              <option
                                key={d.designation_id}
                                value={d.designation_id}
                              >
                                {d.designation}
                              </option>
                            ))}
                          </select>
                        </td>

                        <td>
                          <textarea
                            className="form-control"
                            disabled={!selectedRecs[9]?.selected}
                            value={selectedRecs[9]?.justification || ""}
                            onChange={(e) =>
                              handleRecChange(
                                9,
                                "justification",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* TRAINING (10) */}
                  {(() => {
                    const item = getRecommendationType?.data.find(
                      (x) => x.type_id === 10,
                    );
                    if (!item) return null;

                    return (
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedRecs[10]?.selected || false}
                            onChange={(e) =>
                              handleCheckboxChange(10, e.target.checked)
                            }
                          />
                        </td>

                        <td>{item.type_name}</td>

                        <td colSpan={2}>
                          <select
                            className="form-select"
                            disabled={!selectedRecs[10]?.selected}
                            value={selectedRecs[10]?.training_type || ""}
                            onChange={(e) =>
                              handleRecChange(
                                10,
                                "training_type",
                                e.target.value,
                              )
                            }
                          >
                            <option value="">Select</option>
                            <option value="Behavioural Training">
                              Behavioural Training
                            </option>
                            <option value="Technical Training">
                              Technical Training
                            </option>
                          </select>
                        </td>

                        <td>
                          <textarea
                            className="form-control"
                            disabled={!selectedRecs[10]?.selected}
                            value={selectedRecs[10]?.justification || ""}
                            onChange={(e) =>
                              handleRecChange(
                                10,
                                "justification",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                  })()}

                  {/* NONE OF THE ABOVE (14) */}
                  {(() => {
                    const item = getRecommendationType?.data.find(
                      (x) => x.type_id === 14,
                    );
                    if (!item) return null;

                    return (
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedRecs[14]?.selected || false}
                            onChange={(e) =>
                              handleCheckboxChange(14, e.target.checked)
                            }
                          />
                        </td>

                        <td>{item.type_name}</td>

                        <td colSpan={3}>
                          <textarea
                            className="form-control"
                            disabled={!selectedRecs[14]?.selected}
                            value={selectedRecs[14]?.justification || ""}
                            placeholder="Justification"
                            onChange={(e) =>
                              handleRecChange(
                                14,
                                "justification",
                                e.target.value,
                              )
                            }
                          />
                        </td>
                      </tr>
                    );
                  })()}
                </tbody>
              </table>
              <div className="mt-2 d-flex justify-content-end">
                <button
                  className="btn btn-primary"
                  type="submit"
                  onClick={() => {
                    saveRecomandation();
                  }}
                >
                  Save Recommendation
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllEmployeesHod;
